import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const MicroqualificationGroupsService = {};

const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
});

// ==================== GROUPS ====================

MicroqualificationGroupsService.getAllGroups = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/microqualification-groups",
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.createGroup = async function (groupData) {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/microqualification-groups",
        data: groupData,
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.getGroupById = async function (groupId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}`,
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.updateGroup = async function (groupId, groupData) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}`,
        data: groupData,
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.deleteGroup = async function (groupId) {
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}`,
        headers: getAuthHeaders()
    });
}

// ==================== STUDENTS ====================

MicroqualificationGroupsService.getGroupStudents = async function (groupId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/students`,
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.addStudentsToGroup = async function (groupId, studentIds) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/students/batch`,
        data: { studentIds },
        headers: getAuthHeaders()
    });
}

// Removed updateStudent - students are now managed through User entity

MicroqualificationGroupsService.removeStudentFromGroup = async function (groupId, studentId) {
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/students/${studentId}`,
        headers: getAuthHeaders()
    });
}

// ==================== GRADES ====================

MicroqualificationGroupsService.getDisciplineGrades = async function (groupId, disciplineId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/disciplines/${disciplineId}/grades`,
        headers: getAuthHeaders()
    });
}

MicroqualificationGroupsService.batchAddGrades = async function (groupId, disciplineId, gradesData) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/disciplines/${disciplineId}/grades/batch`,
        data: gradesData,
        headers: getAuthHeaders()
    });
}

// ==================== DOCUMENTS ====================

MicroqualificationGroupsService.downloadAssessmentSheet = async function (groupId, disciplineId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/disciplines/${disciplineId}/assessment-sheet`,
        responseType: 'blob',
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroqualificationGroupsService.downloadTranscript = async function (groupId, studentId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/students/${studentId}/transcript`,
        responseType: 'blob',
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroqualificationGroupsService.generateCertificates = async function (groupId) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/microqualification-groups/${groupId}/certificates`,
        headers: getAuthHeaders()
    });
}

export default MicroqualificationGroupsService;
